import { abbreviate } from 'app-lib/numberUtils'
import { links } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { Loader } from 'ui-framework'
import DaoVM from './DaoVM'

const loader = (
  <div className="flex-center">
    <Loader quantityDots={3} sizeDots="small" />
  </div>
)

export function OnChainProposals({ vm }: { vm: DaoVM }) {
  const { onchainProposals } = vm.dao
  return (
    <div className="panel--simple md-padded-2 margin-bottom-1">
      <h3 className="title-section panel__header">
        <div className="flex-between flex-wrap">
          <span>On-Chain Proposals</span>
          <ExternalLink className="link--discreet" href={links.tally}>
            Vote on Tally
          </ExternalLink>
        </div>
      </h3>
      <div>
        {onchainProposals.length === 0 && vm.dao.onchainProposalsPending && loader}
        {vm.dao.onchainProposalsError && (
          <p className="txt-warning">Could not fetch the list of proposals.</p>
        )}

        {onchainProposals.map((proposal) => {
          const status = proposal.executed ? (
            <span className="dao__vote-status--positive">executed</span>
          ) : proposal.canceled ? (
            <span className="dao__vote-status--negative">canceled</span>
          ) : (
            <span className="dao__vote-status--neutral">{proposal.status.toLowerCase()}</span>
          )
          return (
            <div key={proposal.id.toNumber()} className="margin-bottom-2">
              <h4 className="h3 flex-between">
                {!proposal.description && `#${proposal.id.toNumber()}`} {proposal.description}
                {status}
              </h4>

              <b className="txt-positive margin-right-2">For: {abbreviate(proposal.votes.for)}</b>
              <b className="txt-negative">Against: {abbreviate(proposal.votes.against)}</b>
            </div>
          )
        })}
      </div>
      <div className="bg-alternative padded-1 txt-center">
        Check the details for each proposal in our{' '}
        <ExternalLink className="link--discreet" href={links.daoProposalsGithub}>
          Github Repo
        </ExternalLink>
        .
      </div>
    </div>
  )
}

export default observer(OnChainProposals)
